
import {
  Indicator
} from 'mint-ui';

// 显示加载中进度条
export function showLoading ({state, commit}) {
  // commit('updateLoading', true)
  Indicator.open({
      text: '数据处理中...'
  })
}

// 隐藏加载中进度条
export function hideLoading ({state, commit}) {
  // commit('updateLoading', false)
  Indicator.close()
}

// 显示原图片
export function showFullscreenImg ({state, commit}, obj) {
  if (obj) {
    obj.type = 'show'
    commit('updateFullscreenImage', obj)
  }
}

// 隐藏原图片
export function hideFullscreenImg ({state, commit}) {
  commit('updateFullscreenImage', {
    type: 'hide'
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/nim/widgetUi.js